export const BUSINESS_NAME = "Nicaragua Hosting";
export const WHATSAPP_NUMBER = "50589557076";

export const benefits = [
  {
    title: "Imagen profesional",
    desc: "Proyecta más confianza con correos como ventas@tunegocio.com y una presencia web sólida para tu empresa.",
    icon: "🏢",
  },
  {
    title: "Tu marca primero",
    desc: "Un dominio propio fortalece tu marca y hace que tu negocio se vea más serio y memorable.",
    icon: "🌐",
  },
  {
    title: "Mayor confianza",
    desc: "Tus clientes confiarán más al recibir cotizaciones y atención desde un correo corporativo.",
    icon: "✅",
  },
  {
    title: "Más control y seguridad",
    desc: "Administra usuarios, cuentas y comunicación empresarial con mayor orden y respaldo.",
    icon: "🔒",
  },
];

export const plans = [
  {
    name: "Emprendedor",
    subtitle: "Similar a Hatchling",
    badge: "Para iniciar",
    price: "Desde $12",
    period: "/mes",
    note: "Ideal para una página web empresarial o landing sencilla.",
    cta: "Contratar plan",
    items: [
      "1 sitio web",
      "10 GB de espacio SSD",
      "Ancho de banda no medido",
      "Hasta 10 correos corporativos",
      "SSL incluido",
      "cPanel incluido",
      "WordPress instalable",
      "Webmail, POP3 e IMAP",
      "Protección antispam",
      "Soporte por WhatsApp",
    ],
  },
  {
    name: "Negocio",
    subtitle: "Similar a Baby",
    badge: "Más recomendado",
    price: "Desde $18",
    period: "/mes",
    note: "Para negocios que necesitan más correos, más espacio y mejor presencia digital.",
    cta: "Contratar plan",
    highlighted: true,
    items: [
      "Hasta 3 sitios web",
      "25 GB de espacio SSD",
      "Ancho de banda no medido",
      "Hasta 30 correos corporativos",
      "SSL incluido",
      "cPanel incluido",
      "WordPress instalable",
      "Webmail, POP3 e IMAP",
      "Protección antispam",
      "Soporte prioritario por WhatsApp",
    ],
  },
  {
    name: "Empresa",
    subtitle: "Similar a Business",
    badge: "Para empresas",
    price: "Desde $28",
    period: "/mes",
    note: "Plan completo para empresas con mayor uso de correos, web y soporte.",
    cta: "Solicitar plan empresa",
    items: [
      "Hasta 5 sitios web",
      "50 GB de espacio SSD",
      "Ancho de banda no medido",
      "Hasta 60 correos corporativos",
      "SSL incluido",
      "cPanel incluido",
      "WordPress instalable",
      "Webmail, POP3 e IMAP",
      "Protección antispam",
      "Soporte preferencial",
      "Migración básica incluida",
    ],
  },
];

export const pricingNote =
  "Planes basados en infraestructura reseller. El ancho de banda no medido aplica para uso normal de sitios empresariales, WordPress, correos corporativos y páginas informativas. No aplica para envíos masivos, almacenamiento de archivos pesados o uso intensivo de recursos.";